import {
    getInvoice,
    listInvoices
} from './queries';
import {
    createInvoice,
    deleteInvoice,
    updateInvoice,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {
    CreateInvoice,
    DeleteInvoice,
    GetInvoice,
    Invoice,
    ListInvoices,
    UpdateInvoice
} from "../types.ts";
import { billingApiClient } from "../../billing-api-integration";
import {ListRecordsQuery} from "../../../types";


const client = billingApiClient;

export const fetchRecords = async (query: ListRecordsQuery) => {
    const response = await client.graphql<GraphQLQuery<ListInvoices>>({
                                                                          query: listInvoices,
                                                                          variables: {
                                                                              ...query
                                                                          },
                                                                      });
    console.debug('in the fetch', response)

    return {
        items: response.data?.listInvoices.items,
        nextToken: response.data?.listInvoices.nextToken
    }
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetInvoice>>({
                                                                        query: getInvoice,
                                                                        variables: {id: id},
                                                                    });
    return response.data?.getInvoice;
};

export const add = async (payload: object) => {
    const response = await client.graphql<GraphQLQuery<CreateInvoice>>({
                                                                           query: createInvoice,
                                                                           variables: {input: payload},
                                                                       });
    console.debug('in the service response', response);
    return response.data?.createInvoice;
};

export const update = async (id: string, record: Invoice) => {

    console.debug('IN UPDATE', id, record);

    delete record.created;
    delete record.updated;

    const response = await client.graphql<GraphQLQuery<UpdateInvoice>>({
                                                                           query: (updateInvoice),
                                                                           variables: {input: record},
                                                                       });
    return response.data?.updateInvoice;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeleteInvoice>>({
                                                                           query: (deleteInvoice),
                                                                           variables: {input: {id: id}},

                                                                       });
    return response.data?.deleteInvoice;
};
